import { inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { withSessionStorage, withStorageSync } from '@angular-architects/ngrx-toolkit';
import { NgkAuthService } from '@kin/ngk-auth';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

export type PlatformUserType = 'customer' | null;

/**
 * Signal store that exposes NgkAuthService observables as signals
 * and manages app-level platform auth state (return URL, user type).
 */
export const PlatformAuthStore = signalStore(
  { providedIn: 'root' },
  withState({
    returnUrl: null as string | null,
    userType: null as PlatformUserType,
  }),
  withComputed(() => {
    const authService = inject(NgkAuthService);

    const isLoggedIn = toSignal(authService.isLoggedIn$, { initialValue: false });
    const isIdle = toSignal(authService.idleService.isIdle$, { initialValue: false });
    const hasLoggedOut = toSignal(authService.hasLoggedOut$, { initialValue: false });

    return { isLoggedIn, isIdle, hasLoggedOut };
  }),
  withMethods((store) => ({
    setReturnUrl(url: string | null): void {
      patchState(store, { returnUrl: url });
    },
    setUserType(type: PlatformUserType): void {
      patchState(store, { userType: type });
    },
    reset(): void {
      patchState(store, { returnUrl: null, userType: null });
    },
  })),
  withStorageSync({ key: 'platformAuth', autoSync: true }, withSessionStorage()),
);
